import { SwitchProps, Switch } from "antd";
import React from "react";
import "./ConfigSwitch.css";

export const ConfigSwitch = (props: SwitchProps) => {
  return (
    <Switch
      {...props}
      className={`config-switch ${props.className ? props.className : ""}`}
    />
  );
};
